// extracted by mini-css-extract-plugin
export default {"bimContainer":"bim_bimContainer__kI03l","section":"bim_section__xGd5R","lastUpdate":"bim_lastUpdate__ujd0o","lastUpdateDate":"bim_lastUpdateDate__q+CKe"};